<template>
  <section-box>
    <div class="timeline_list">
      <app-empty-message
        :count="count"
        :heading="emptyMessage"
      >
        <div
          v-for="(item, index) in sortedItems"
          :key="index"
        >
          <timeline-note v-if="isNote(item)" :note="item"></timeline-note>

          <timeline-text v-if="isText(item)" :text="item">
            <template v-slot:column>
              <timeline-list-column
                v-if="!isMobile"
                :item="item"
                :is-on-contact-modal="isOnContactModal"
                :is-on-lead-modal="isOnLeadModal"
              ></timeline-list-column>
            </template>
          </timeline-text>

          <timeline-call v-if="isCall(item)" :call="item">
            <template v-slot:column>
              <timeline-list-column
                v-if="!isMobile"
                :item="item"
                :is-on-contact-modal="isOnContactModal"
                :is-on-lead-modal="isOnLeadModal"
              ></timeline-list-column>
            </template>
          </timeline-call>

          <timeline-email v-if="isEmail(item)" :email="item">
            <template v-slot:column>
              <timeline-list-column
                v-if="!isMobile"
                :item="item"
                :is-on-contact-modal="isOnContactModal"
                :is-on-lead-modal="isOnLeadModal"
              ></timeline-list-column>
            </template>
          </timeline-email>

          <timeline-task v-if="isTask(item)" :task="item"></timeline-task>

          <timeline-appointment v-if="isAppointment(item)" :appointment="item"></timeline-appointment>

          <timeline-activity-record v-if="isActivity(item)" :activity="item"></timeline-activity-record>
        </div>

        <slot></slot>
      </app-empty-message>
    </div>
  </section-box>
</template>

<script>
import {ENUMS} from "../../services/enums";
import {MODELS} from "../../services/models";
import TimelineNote from "./TimelineNote";
import TimelineText from "./TimelineText";
import TimelineCall from "./TimelineCall";
import TimelineEmail from "./TimelineEmail";
import TimelineTask from "./TimelineTask";
import TimelineAppointment from "./TimelineAppointment";
import TimelineActivityRecord from "./TimelineActivityRecord";
import TimelineItem from "./TimelineItem";
import TimelineListColumn from "./TimelineListColumn";

export default {
  name: "TimelineList",
  components: {
    TimelineListColumn,
    TimelineItem,
    TimelineActivityRecord,
    TimelineAppointment,
    TimelineTask,
    TimelineEmail,
    TimelineCall,
    TimelineText,
    TimelineNote
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    isOnLeadModal: {
      type: Boolean,
      default: false,
    },
    isOnContactModal: {
      type: Boolean,
      default: false,
    },
    emptyMessage: {
      type: String,
      default: "There is nothing here"
    },
    overrideEmpty: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    sortedItems() {
      const copy = this.$utils.clone(this.items);

      return copy.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    },
    count() {
      const count = this.sortedItems.length;

      if (count > 0) {
        return count;
      } else if (this.overrideEmpty) {
        return 1;
      } else {
        return 0;
      }
    }
  },
  methods: {
    isNote(item) {
      return item.class_name === MODELS.Note.class_name;
    },
    isText(item) {
      return (
        item.class_name === MODELS.CommunicationLog.class_name &&
        item.type === ENUMS.CommunicationTypeEnum.Text.value
      );
    },
    isCall(item) {
      return (
        item.class_name === MODELS.CommunicationLog.class_name &&
        (item.type === ENUMS.CommunicationTypeEnum.Call.value || item.type === ENUMS.CommunicationTypeEnum.VideoCall.value)
      );
    },
    isEmail(item) {
      return (
        item.class_name === MODELS.CommunicationLog.class_name &&
        item.type === ENUMS.CommunicationTypeEnum.Email.value
      );
    },
    isTask(item) {
      return (
        item.class_name === MODELS.Activity.class_name &&
        item.type === ENUMS.ActivityTypeEnum.Task.value
      );
    },
    isAppointment(item) {
      return (
        item.class_name === MODELS.Activity.class_name &&
        item.type === ENUMS.ActivityTypeEnum.Appointment.value
      );
    },
    isActivity(item) {
      return (
        item.class_name === MODELS.Activity.class_name &&
        item.type !== ENUMS.ActivityTypeEnum.Task.value &&
        item.type !== ENUMS.ActivityTypeEnum.Appointment.value
      );
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.timeline_list {
  margin: -14px; // this removes the padding from the parent section-box
  padding: 6px 10px;
  height: 600px;
  overflow-y: scroll;

  @include mobile {
    height: auto;
    overflow-y: visible;
  }
}
</style>
